@import ../../../styles/helpers

.container
    display: flex
    flex-direction: column

    &__hero
        padding: 20px
        background-color: #2C2F35
        border-radius: 20px

.row
    display: flex
    justify-content: space-between
    margin-top: 34px

    &__player
        display: flex
        align-items: center
        height: 41px

        img
            width: 41px
            height: 41px
            margin-right: -15px
            border-radius: 100px

        &__comment
            font-size: 16px
            line-height: 19px

    &__rating
        display: flex
        justify-content: flex-end

        &__fill
            width: 21px
            height: 21px
            color: linear-gradient(0deg, #FEA63B 0%, #F9CD24 99.86%)

        &__outline
            width: 20px
            height: 20px
            color: #FFFFFF
            opacity: 0.4

        &__text
            font-size: 16px
            line-height: 19px
            text-align: right

.column
    display: flex
    flex-direction: column
    justify-content: space-between
    gap: 10px

.hero
    position: relative
    max-width: 1070px
    margin: 0 auto
    max-height: 400px
    overflow: hidden
    border-radius: 62px
    +m
        border-radius: 44px
        height: 400px
        margin-top: 3px
    img
        width: 100%
    iframe
        width: 100%
        aspect-ratio: 1.777/1
        height: 100%
        +m
            width: auto
            min-width: 100%
            height: 400px
            position: absolute
            top: 0
            left: 50%
            transform: translateX(-50%)

.titlebox
    position: absolute
    left: 50px
    top: 50px
    .subtitle
        margin-top: 10px
    +m
        top: 45px
        left: 25px
        .subtitle
            margin-top: 0px
            font-weight: 500
            font-size: 14px
            letter-spacing: 2px
        .title
            line-height: 60px

    
    

    
.textbox
    background-color: #2e2822
    width: 80%
    max-width: 700px
    padding: 25px
    border-radius: 15px

.subtitle
    margin-top: 60px

.title
    margin-bottom: 24px
    line-height: 1.4
    font-size: 52px
    +m
        font-size: 45px

.text
    margin-top: 2px

.player
    display: flex
    align-items: center
    height: 28px

    margin-top: 67px
    margin-bottom: 24px

    img
        width: 28px
        height: 28px
        margin-right: -10px
        border-radius: 100px

    &__comment
        margin-left: 20px
        font-size: 15px
        line-height: 18px

.rating
    margin-top: 21px
    margin-bottom: 52px

    &__fill
        width: 20px
        height: 20px
        color: #FBBA18

    &__outline
        width: 20px
        height: 20px
        color: #FFFFFF
        opacity: 0.4

.buttonbox
    margin-top: 35px
    display: flex
    gap: 24px

.overlayActioner
    width: 100%
    height: 100%
    z-index: 99
    position: absolute
    left: 0
    top: 0

.playbutton
    height: 58px
    position: absolute
    bottom: 50px
    left: 50px
    border-radius: 50px
    padding: 35px 45px
    background-color: #FACC27
    color: #EC540B
    box-shadow: 0px 0px 30px rgba(250,204,39,0.4)
    +m
        width: inherit
        bottom: 30px
        left: 25px

.addbutton
    display: flex
    justify-content: center
    align-items: center
    height: 53px
    width: 192px
    color: white
    background: transparent
    border: 1px solid #FFFFFF
    border-radius: 20px
    font-weight: 900
    gap: 8px
    cursor: pointer

    +m
        width: inherit
        padding-left: 20px
        padding-right: 20px


.sharebutton
    display: flex
    justify-content: center
    align-items: center
    height: 53px
    width: 61px
    background: transparent
    border: 1px solid #FFFFFF
    border-radius: 20px
    cursor: pointer
